export var ADDRESS_BLOCK_VIEW_STATUSES = {
  checkAddress: 'checkAddress',
  hasConnectionOnAddress: 'hasConnectionOnAddress',
  hasTicketOnAddress: 'hasTicketOnAddress',
  highSpeedAvailable: 'highSpeedAvailable',
  speedLimit: 'speedLimit',
  isNotAvailable: 'isNotAvailable',
  success: 'success'
};
export var AVAILABLE_STEPS_FOR_PHONE_INPUT = [ADDRESS_BLOCK_VIEW_STATUSES.hasConnectionOnAddress, ADDRESS_BLOCK_VIEW_STATUSES.hasTicketOnAddress, ADDRESS_BLOCK_VIEW_STATUSES.highSpeedAvailable, ADDRESS_BLOCK_VIEW_STATUSES.speedLimit];
export var CHECK_ANOTHER_ADDRESS_STEPS = [ADDRESS_BLOCK_VIEW_STATUSES.isNotAvailable, ADDRESS_BLOCK_VIEW_STATUSES.hasConnectionOnAddress, ADDRESS_BLOCK_VIEW_STATUSES.hasTicketOnAddress];
export var AVAILABLE_STEPS = [ADDRESS_BLOCK_VIEW_STATUSES.speedLimit, ADDRESS_BLOCK_VIEW_STATUSES.highSpeedAvailable];

/**
  Статусы IsAvailable (speedLimit) и IsHighSpeedAvailable получаются в случае если:
  IsAvailable: connectionState === IsAvailable && highSpeedAvailable
  IsHighSpeedAvailable: connectionState === IsAvailable && !highSpeedAvailable
 */
export var STEPS_BY_RESPONSE_STATUS = {
  HasConnectionOnAddress: 'hasConnectionOnAddress',
  HasTicketOnAddress: 'hasTicketOnAddress',
  IsAvailable: 'speedLimit',
  IsNotAvailable: 'isNotAvailable',
  IsHighSpeedAvailable: 'highSpeedAvailable'
};
export var GOAL_FTTB_AND_FMC = {
  ConvergentTariffCallbackLongFormNew: 'ConvergentTariffCallbackLongFormNew',
  HomeTariffCallbackLongForm: 'HomeTariffCallbackLongForm',
  FttbAddressConnectionIsNotPossibleNotInME: 'FttbAddressConnectionIsNotPossibleNotInME'
};